<mat-card *ngIf="view == 'Login' " [style.background-color]="community?.login_card_background_color_hex"
          [style.color]="community?.login_card_text_color_hex"
          class="loginPage">
    <ng-container *ngIf="!initialLoad">
        <div *ngIf="companyImg" class="w-100 flex-row align-items-center mt-10 loginLogoContainer">
            <img [alt]="companyName + ' Logo'" [src]="companyImg" class="mx-auto logoBg loginLogo">
        </div>
        <mat-card-content>
            <div [class.centering]="community?.retired_community"
                 [class.splitLogin]="community?.login_text && !community?.retired_community">
                <div *ngIf="community?.login_text" class="p-20 pb-0 flex-col flex-space-between loginText">
                    <div *ngIf="community?.login_text_rendered" [innerHTML]="community?.login_text_rendered"></div>
                    <ng-container *ngIf="!community?.login_text_rendered">{{ community?.login_text }}</ng-container>
                    <button (click)="this.goToRegister()" *ngIf="!community?.retired_community"
                            [appCustomButtonColours]="community?.registration_button_color_hex" class="w-100"
                            color="primary"
                            mat-raised-button>
                        Register now
                    </button>
                </div>
                <div *ngIf="!community?.retired_community" class="loginSection">
                    <h2>Log in</h2>
                    <form [formGroup]="loginForm">
                        <mat-form-field appearance="outline" class="w-100" color="accent">
                            <mat-label>Email address</mat-label>
                            <input (keyup.enter)="passwordField.focus()" appAutofill formControlName="email" matInput
                                   type="email"/>
                            <mat-error *ngIf="loginForm.controls['email'].hasError('required')">
                                This field is required
                            </mat-error>
                            <mat-error *ngIf="loginForm.controls['email'].hasError('email')">
                                Please enter a valid email address
                            </mat-error>
                        </mat-form-field>
                        <mat-form-field appearance="outline" class="w-100" color="accent">
                            <mat-label>Password</mat-label>
                            <input #passwordField (keyup.enter)="loginIfValid()"
                                   [type]="passwordType" appAutofill formControlName="password" matInput/>
                            <button (click)="showPassword()"
                                    [matTooltip]="passwordType == 'password' ? 'Show password' : 'Hide password'"
                                    class="h-fit-content p0" mat-icon-button
                                    matSuffix
                                    type="button">
                                <mat-icon *ngIf="passwordType == 'password'" color="accent">remove_red_eye
                                </mat-icon>
                                <mat-icon *ngIf="passwordType == 'text'" color="accent">highlight_off</mat-icon>
                            </button>
                            <mat-error *ngIf="loginForm.controls['password'].hasError('required')">
                                This field is required
                            </mat-error>
                        </mat-form-field>
                    </form>
                    <div class="text-align-center mb-10">
                        <button (click)="this.view = 'Forgot'" mat-button>
                            Forgot password?
                        </button>
                        <br>
                        <button (click)="this.goToRegister()" *ngIf="!community || !community?.login_text"
                                [appCustomButtonColours]="community?.registration_button_color_hex"
                                mat-button class="w-100">
                            Register
                        </button>
                    </div>
                    <button (click)="login()" [appCustomButtonColours]="community?.login_button_color_hex"
                            [disabled]="loginForm.invalid || loading"
                            autofocus class="w-100" color="accent" mat-flat-button>
                        Log in
                        <mat-icon *ngIf="loading">
                            <mat-spinner color="accent"></mat-spinner>
                        </mat-icon>
                    </button>
                </div>
            </div>
        </mat-card-content>
    </ng-container>
    <ng-container *ngIf="initialLoad">
        <mat-progress-spinner class="loader mx-auto my-10" color="accent" mode="indeterminate"></mat-progress-spinner>
    </ng-container>
</mat-card>
<mat-card *ngIf="view == 'Forgot'" [style.background-color]="community?.login_card_background_color_hex"
          [style.color]="community?.login_card_text_color_hex"
          class="forgotPanel loginPage">
    <div *ngIf="companyImg" class="w-100 flex-row align-items-center mt-10 loginLogoContainer">
        <img [alt]="companyName + ' Logo'" [src]="companyImg" class=" mx-auto logoBg loginLogo">
    </div>
    <mat-card-header>
        <mat-card-subtitle>
            <h3>Forgot Password</h3>
        </mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
        <form [formGroup]="requestPasswordForm">
            <mat-form-field appearance="outline" class="w-100" color="accent">
                <mat-label>Email address</mat-label>
                <input formControlName="email" matInput type="email"/>
                <mat-error *ngIf="requestPasswordForm.controls['email'].hasError('required')">
                    This field is required
                </mat-error>
                <mat-error *ngIf="requestPasswordForm.controls['email'].hasError('email')">
                    Please enter a valid email address
                </mat-error>
            </mat-form-field>
        </form>
        <button (click)="this.view = 'Login'" mat-button>
            Remembered your password?
        </button>
    </mat-card-content>
    <mat-card-actions class="text-center">
        <button (click)="passwordResetRequest()" [disabled]="requestPasswordForm.invalid || loading"
                class="mx-auto"
                color="accent" mat-flat-button>
            Recover password
            <mat-icon *ngIf="loading">
                <mat-spinner color="accent"></mat-spinner>
            </mat-icon>
        </button>
    </mat-card-actions>
</mat-card>
<mat-card *ngIf="view == 'Create'" [style.background-color]="community?.login_card_background_color_hex"
          class="createCard">
    <div *ngIf="community.register_page_logo" class="w-100 d-flex justify-content-center">
        <div class="w-100 flex-row align-items-center mt-10 registerLogoContainer">
            <img [alt]="companyName + ' Logo'" [src]="community.register_page_logo" class=" mx-auto logoBg loginLogo">
        </div>
    </div>
    <mat-card-title class="text-center">
        <div *ngIf="community?.registration_page_title_text_rendered"
             [innerHTML]="community?.registration_page_title_text_rendered"></div>
        <h1 *ngIf="!community?.registration_page_title_text_rendered" class="registerTitle"> Join {{ companyName }}'s
            Community</h1>
    </mat-card-title>
    <mat-card-content>
        <app-register [community]="community"></app-register>
    </mat-card-content>
</mat-card>
